import { Descriptions, Flex } from 'antd';
import { Duration } from 'dayjs/plugin/duration';

import {
  ShowMoreOnMobileState,
  ShowMoreOnMobileStateKeys,
  SHOW_MORE_ON_MOBILE_STATE_KEYS,
} from 'business/shift-report/report/pages/ReportView/types';
import {
  GetShiftReportPdfMetadataQuery,
  GetPreviousPrintReportQuery,
  GetIndicatorResultsQuery,
} from 'generated/graphql';
import { ShowMoreToggle } from 'ui/show-more-button';

import { useBuildExcavationAndBuildDescriptionItems } from './excavation-and-build/use-build-excavation-and-build-description-items';
import { useBuildMetadataDescriptionItems } from './report-metadata/use-build-metadata-description-items';
import { useBuildTotalAvailabilityDescriptionItems } from './total-availability/use-build-total-availability-description-items';

type ReportViewMobileMetadataContainerProps = {
  report: NonNullable<GetShiftReportPdfMetadataQuery['shiftReport']>;
  showMore: ShowMoreOnMobileState;
  toggleShowMore: (key: ShowMoreOnMobileStateKeys) => () => void;

  previousReport: GetPreviousPrintReportQuery['shiftReport'][0] | undefined;
  averageExcavationPerRing: string | null;
  averageBuildPerRing: string | null;

  indicators: NonNullable<
    GetIndicatorResultsQuery['calculateIndicatorResults']
  >['data'];

  totalTasksTime: Duration;
  totalCriticalTasksTime: Duration;
};

export const ReportViewMobileMetadataContainer = ({
  report,
  showMore,
  toggleShowMore,
  totalTasksTime,
  totalCriticalTasksTime,
  indicators,
  previousReport,
  averageExcavationPerRing,
  averageBuildPerRing,
}: ReportViewMobileMetadataContainerProps) => {
  const reportMetadataItems = useBuildMetadataDescriptionItems({
    report,
    showMoreOnMobile: showMore.metadata,
  });

  const totalAvailabilityItems = useBuildTotalAvailabilityDescriptionItems({
    totalTasksTime,
    totalCriticalTasksTime,
    indicators,
  });

  const excavationAndBuildItems = useBuildExcavationAndBuildDescriptionItems({
    previousReport,
    averageExcavationPerRing,
    averageBuildPerRing,
  });

  const metadataItems = [
    ...reportMetadataItems,
    ...(showMore.metadata
      ? [...excavationAndBuildItems, ...totalAvailabilityItems]
      : []),
  ];

  return (
    <Flex vertical gap={8}>
      <Descriptions
        items={metadataItems}
        column={{ xs: 1, sm: 1, md: 1, lg: 6, xl: 6, xxl: 6 }}
        className="header-info"
        bordered={true}
      />
      <ShowMoreToggle
        enableToggle
        toggleState={showMore.metadata}
        toggleFunc={toggleShowMore(SHOW_MORE_ON_MOBILE_STATE_KEYS.METADATA)}
      />
    </Flex>
  );
};
